import { render, staticRenderFns } from "./CareHistory.vue?vue&type=template&id=7bbfbb5c&"
import script from "./CareHistory.vue?vue&type=script&lang=js&"
export * from "./CareHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports